/* eslint-disable import/named */
import { Button, Center, Text, VStack } from '@chakra-ui/react';
import { FallbackProps } from 'react-error-boundary';

function ErrorBoundaryFallback({ resetErrorBoundary }: FallbackProps) {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <Center w="full" h="100vh">
      <VStack w="full" maxW="500px" spacing="3">
        <Text fontSize="xl" textAlign="center">
          Something Went Wrong. <br /> We&apos;re working on getting things
          fixed.
        </Text>

        <VStack w="max-content">
          <Button hidden w="full" size="lg" onClick={resetErrorBoundary}>
            Retry
          </Button>
          <Button w="full" size="lg" onClick={reloadPage}>
            Reload Page
          </Button>
        </VStack>
      </VStack>
    </Center>
  );
}

export default ErrorBoundaryFallback;
